export const resolveValueType = (value) => {
    if (Array.isArray(value)) {
        if (value.length && typeof value[0] !== 'object') {
            return value.join(', ');
        }
        return `${value.length}`;
    }
    if (value === null) {
        return '';
    }
    return value;
};
export const resolveValueTypeToString = (value) => {
    if (Array.isArray(value)) {
        if (value.length && typeof value[0] !== 'object') {
            return value.join(', ');
        }
        return `${value.length}`;
    }
    if (value === null) {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    // catch all for value
    return JSON.stringify(value);
};
//# sourceMappingURL=resolveValueType.js.map